import CancelOfferDialog from './CancelOfferDialog.vue'
import { ProgrammaticDialog } from '~/ui/elements'

export const CancelOfferDialogProgrammatic = ProgrammaticDialog(CancelOfferDialog)
export default CancelOfferDialog
